<section class="d-flex justify-content-center align-items-center vh-100" style="background-color: var(--color-bg)">
  <div class="p-4 rounded shadow" style="background-color: var(--color-bg-secondary); width: 30rem">
    <div class="d-flex justify-content-center mb-3">
      <img src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Logo" class="img-fluid" style="max-height: 100px" />
    </div>
    <h3 class="sub-title p-4 login-title">Tilgang til Arbeidsgiverportalen</h3>
    <p class="custom-spacing fw-normal fs-6 align-items-left p-3">Det kreves egen tilgang til Arbeidsgiverportalen, og du kan bli bedt om å søke om tilgang ved første innlogging.</p>
    <div class="d-flex justify-content-center mb-4">
      <button class="p-3 button primary" (click)="login()">Logg inn</button>
    </div>
    <div class="d-flex justify-content-center link">
      <a routerLink="/brukermanual">Brukermanual</a>
    </div>
  </div>
</section>
